import { Page } from "@/components/common/Page";
import { JobStyleScheduleVariables } from "@/hooks/mutations/useJobStyleScheduleMutation";
import { UploadedSessionData } from "@/types/common.types";
import { useState } from "react";
import { Eyebrow } from "../common/brand/Eyebrow";
import UploadForm from "./UploadAndScheduleForm";
import { Separator } from "../ui/separator";
import UploadedJobTable from "./table/UploadedJobTable";
import useAnalyticsManager from "@/hooks/miscellaneous/useAnalyticsManager";

const Upload = () => {
  const [uploadedSessionData, setUploadedSessionData] =
    useState<UploadedSessionData | null>(null);
  const [jobName, setJobName] = useState("");
  const [scheduledJobData, setScheduledJobData] =
    useState<JobStyleScheduleVariables | null>(null);

  const onUploadSuccess = (
    uploadedFilesData: UploadedSessionData,
    jobName: string
  ) => {
    setUploadedSessionData(uploadedFilesData); // This will trigger re-render of UploadedStyleTable
    setJobName(jobName);
  };

  const onScheduleSuccess = (data: JobStyleScheduleVariables) => {
    setScheduledJobData(data);
  };

  const { sendEvent } = useAnalyticsManager();

  sendEvent("upload_screen_viewed");

  return (
    <Page className="overflow-x-scroll">
      <div className="flex w-full flex-col items-start gap-2">
        <Eyebrow>[ UPLOAD · SCHEDULE ]</Eyebrow>
        <h1 className="font-display text-[34px] font-medium leading-[1.05] tracking-[-0.02em] text-brand-text">
          Upload.
        </h1>
        <span className="font-mono text-[11px] uppercase tracking-[0.18em] text-brand-muted">
          Ingest a dataset and schedule a job
        </span>
      </div>
      <div className="mt-3 flex items-start gap-6">
        <div className="flex w-full">
          <UploadForm
            className="flex-start flex-1"
            onUploadSuccess={onUploadSuccess}
            onScheduleSuccess={onScheduleSuccess}
          />
        </div>
      </div>
      <Separator className="my-10" />
      {uploadedSessionData && (
        <UploadedJobTable
          uploadedSessionData={uploadedSessionData}
          onStyleIdClick={() => {}}
        />
      )}
    </Page>
  );
};

export default Upload;
